exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-invalid {\n  border-color: red;\n}\n\n#invite {\n    min-height: 200px;\n}\n\n.drop-container {\n    padding: 40px 0;\n    border: 2px dashed #02baf2;\n    border-radius: 10px;\n    background: #f4fcff;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: center;\n        justify-content: center;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-left: 50px;\n    margin-right: 50px;\n}\n\n.start-upload-btn, .upload-button {\n    margin: 10px auto;\n    background: #00babf;\n    border-color: #00babf;\n    outline: none;\n    font-size: 18px;\n    text-align: center;\n    padding: 10px 30px;\n    cursor: pointer;\n    color: #fff;\n    border: none;\n    font-weight: 200;\n    transition: all .25s linear;\n    border-radius: 4px;\n\n    padding: 6px 12px;\n    margin-bottom: 0;\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1.42857143;\n    text-align: center;\n    white-space: nowrap;\n    vertical-align: middle;\n}\n\n.start-upload-btn input, .upload-button input {\n    display: none;\n}\n\n.hide {\n    display: none\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/invite/invite.component.css
// module id = ../../../../../src/app/pages/invite/invite.component.css
// module chunks = main